import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentPlanTextService {

  paymentPlanTextSubject = new BehaviorSubject<any>({});
  $paymentPlanText = this.paymentPlanTextSubject.asObservable();

  constructor() { }
}
